import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

import createHistory from 'history/createBrowserHistory'
import createSagaMiddleware from 'redux-saga'
import { Provider } from 'react-redux'
import { routerMiddleware } from 'react-router-redux'
import { applyMiddleware, createStore, compose } from 'redux'
//import logger from 'redux-logger'

import App from './App'
import Saga from './saga'
import reducer from './reducer'
import firebase from 'firebase'
import { reactReduxFirebase, getFirebase } from 'react-redux-firebase'

import { firebase as fbConfig, reduxFirebase as reduxConfig } from './config'


firebase.initializeApp(fbConfig)

//create middleWares
const history = createHistory()
const sagaMiddleware = createSagaMiddleware()

const middlewares = applyMiddleware(
    routerMiddleware(history),
    sagaMiddleware,
//    logger

)

export const store = createStore(
    reducer, 
    compose(
        reactReduxFirebase(firebase, reduxConfig),
        middlewares)
    )

    sagaMiddleware.run(Saga, getFirebase)
ReactDOM.render(
    <Provider store={store}>
        <App history={history}/>
    </Provider>, 
    document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js